import { ITreeItem, ITreePathItem } from './types';

export const filterPathItems = (path: ITreePathItem[]): ITreePathItem[] => {
  return path.filter((pathItem) => pathItem.level > 0);
};

export const buildBreadcrumbLabels = (
  path: ITreePathItem[]
): { pathLabels: string[]; itemName: string } => {
  const pathLabels = path.map((pathItem) => pathItem.name || '');

  const itemName = pathLabels.pop() || '';

  return { pathLabels, itemName };
};

export const createTreeItemFromPath = <T extends ITreeItem>(
  pathItem: ITreePathItem,
  currentItem: T,
  index: number
): T => {
  return {
    id: pathItem.id,
    name: pathItem.name || '',
    level: pathItem.level,
    path: currentItem.path?.slice(0, index + 1),
  } as T;
};
